<template>
    <Dashboard></Dashboard>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const Dashboard = defineAsyncComponent(() =>
    import("../../components/Hr/TempRequest/Dashboard.vue")
);

export default {
    name: "Labor_logs",
    components: { Dashboard, AuthLayout },
};
</script>
